import { render, staticRenderFns } from "./option-fee-toward-purchase.vue?vue&type=template&id=47123a66"
import script from "./option-fee-toward-purchase.vue?vue&type=script&lang=js"
export * from "./option-fee-toward-purchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports